import { useEffect, useState } from "react";
import { Phone, CalendarCheck, Menu, X } from "lucide-react";
import { SITE, LOGO } from "../lib/site";
import { Link } from "react-router-dom";

const NAV = [
  { id: "home", label: "Home" },
  { id: "servizi", label: "Servizi" },
  { id: "centro", label: "Il centro" },
  { id: "orari", label: "Orari" },
  { id: "contatti", label: "Contatti" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      translate="no"
      lang="it"
      className={`notranslate fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[var(--ee-ivory)]/85 backdrop-blur-md border-b border-[var(--ee-line)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[68px] flex items-center justify-between">
        <a
          href="#home"
          data-testid="brand-logo"
          aria-label="Estetica Elite — Home"
          className="flex items-center group"
          onClick={() => setOpen(false)}
        >
          <img
            src={LOGO}
            alt="Estetica Elite"
            className="h-12 sm:h-14 w-auto"
            loading="eager"
            decoding="async"
          />
        </a>

        <nav
          data-testid="desktop-nav"
          className="hidden lg:flex items-center gap-8"
        >
          {NAV.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              data-testid={`nav-${item.id}`}
              className="text-[13px] font-medium text-[var(--ee-ink-soft)] hover:text-[var(--ee-rose-strong)] transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={SITE.phoneTel}
            data-testid="header-call-btn"
            className="ee-btn ee-btn-ghost !py-2.5 !px-4 text-[13px]"
          >
            <Phone size={15} strokeWidth={1.8} />
            Chiama ora
          </a>
          <Link
            to="/prenota"
            data-testid="header-book-btn"
            className="ee-btn ee-btn-primary !py-2.5 !px-5 text-[13px]"
          >
            <CalendarCheck size={15} strokeWidth={1.8} />
            Prenota online
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden p-2 text-[var(--ee-ink)]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Apri menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        data-testid="mobile-menu"
        className={`lg:hidden overflow-hidden transition-[max-height] duration-300 bg-[var(--ee-ivory)] border-t border-[var(--ee-line)] ${
          open ? "max-h-[420px]" : "max-h-0"
        }`}
      >
        <div className="px-6 py-5 flex flex-col gap-1">
          {NAV.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              data-testid={`mobile-nav-${item.id}`}
              onClick={() => setOpen(false)}
              className="py-2.5 text-[15px] text-[var(--ee-ink)] border-b border-[var(--ee-line)] last:border-b-0"
            >
              {item.label}
            </a>
          ))}
        </div>
      </div>
    </header>
  );
}
